import { WEB_PUSH_INSTALL_INTENT_STORAGE_KEY } from "@/lib/webPushInstallIntent";

export function completeWebPushInstallIntent() {
  if (typeof window === "undefined") return;

  try {
    window.localStorage.removeItem(WEB_PUSH_INSTALL_INTENT_STORAGE_KEY);
  } catch {
    // In-memory prompt state still prevents a duplicate during this render lifecycle.
  }
}
